import React, { useState } from "react";
import { Button, Col, DatePicker, Form, Row } from "antd";
import { FormBox, InputBox } from "../../../../components/AntdAddons";
import { SearchOutlined } from "@ant-design/icons";
import dayjs, { Dayjs } from "dayjs";
import { validations } from "../../../../config/validations/validations";
import { disabledSaveBtn } from "../../../../config/Global";

const SearchList: React.FC<any> = (props) => {
  const { getList } = props;

  const [form] = Form.useForm();

  const [loading, setLoading] = useState<boolean>(false);
  const [disabledClear, setDisabledClear] = useState(true);
  const [disabledSearch, setDisabledSearch] = useState(true);

  const handleSubmit = (data) => {
    setLoading(true);
    let prefix;
    let report_date;

    if (data?.prefix) {
      prefix = data?.prefix;
    }

    report_date = data?.report_date
      ? dayjs(data?.report_date).format("YYYY-MM-DD")
      : "";

    const payload = {
      type: data?.type,
      date: report_date ?? "",
      prefix: prefix ?? "",
    };
    if (payload) {
      setLoading(false);
      getList(payload);
      setDisabledClear(false);
    }
  };

  // for validation
  const handleChange = () => {
    form
      .validateFields()
      .then(() => {
        const isDisabled = disabledSaveBtn(form);
        setDisabledSearch(isDisabled);
      })
      .catch((e: any) => {
        setDisabledSearch(true);
        console.warn(e);
      });
  };

  const disabledDate = (current: Dayjs) => {
    // Can not select days after today
    return current && current.isAfter(dayjs().endOf("day"));
  };

  return (
    <FormBox
      className="filterForm"
      form={form}
      onFinish={handleSubmit}
      onChange={handleChange}
      validateTrigger={["onBlur", "onInput"]}
      autoComplete="off"
    >
      <Row gutter={20} align={"middle"}>
        <Col xs={24} md={12} lg={6} xxl={6}>
          <InputBox.Text
            label="Prefix"
            name={"prefix"}
            rules={[validations.pattern.whitespace, validations.pattern.prefix]}
          />
        </Col>
        <Col xs={12} md={12} lg={6} xl={6}>
          <Form.Item label="Select Date" name={"report_date"}>
            <DatePicker
              placeholder={"Select Date"}
              disabledDate={disabledDate}
              onChange={(date) => {
                // Enable or disable search based on date value
                setDisabledSearch(!date);
                setDisabledClear(!date);
              }}
            />
          </Form.Item>
        </Col>

        <Col xs={12} md={12} lg={6} xl={3}>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            disabled={disabledSearch}
          >
            <SearchOutlined /> Search
          </Button>
        </Col>
        <Col xs={12} md={12} lg={6} xl={3}>
          <Button
            type="default"
            htmlType="reset"
            disabled={disabledClear}
            onClick={() => {
              getList();
              form.resetFields();
              setDisabledSearch(true);
              setDisabledClear(true);
            }}
          >
            Clear
          </Button>
        </Col>
      </Row>
    </FormBox>
  );
};

export default SearchList;
